import React from "react"
import { graphql } from "gatsby"
import Layout from "../../components/Layout/layout"
import SEO from "../../components/seo"
import PropTypes from "prop-types"
import Ariane from "../../components/Ariane/ariane"
import { GalerieTitle } from "./styled-components/galerie-styled"
import {
  galerieContainer,
  galerieTitle,
  masonryGrid,
  masonryGridColumn,
  galerieImageContainer,
  editButton,
} from "./styles/detailsGalerie.module.scss"
import ContentTransformer from "../../components/Transformers/content-transformer"
import FinalGalerieComponent from "../../components/Home/GalerieImages/final-galerie-component"
import { LightBoxImage } from "gatsby-theme-blank/src/components/LightBoxImage/light-box-image"
import EditButton from "../../components/EditButton/edit-button"

//-----------------------QueryGraphql---------------------------//

export const query = graphql`
  query ($slug: String!) {
    nodeGalerieDImages(path: { alias: { eq: $slug } }) {
      ...GalerieItem
    }
  }
`
//-----------------------QueryGraphql---------------------------//

//-----------------------Component---------------------------//

const GalerieTemplate = ({ data }) => {
  const galerie = data.nodeGalerieDImages
  return (
    <FinalGalerieComponent data={galerie} role="list">
      {({ images }) => (
        <Layout isDetail={true}>
          <SEO
            title={galerie.title}
            description={
              "Dans cette page, vous découvrez la galerie suivante : " +
              galerie.title
            }
          />
          <Ariane isListing={true} pageName={galerie.title} />
          <section className={galerieContainer}>
            <GalerieTitle className={galerieTitle}>
              <EditButton
                link={"/node/" + galerie.drupal_internal__nid + "/edit"}
                addedClass={editButton}
              />
              {galerie.title}
            </GalerieTitle>
            {galerie.body?.processed ? (
              <ContentTransformer content={galerie.body.processed} />
            ) : galerie.body?.summary ? (
              <ContentTransformer content={galerie.body.summary} />
            ) : null}
            <div className={galerieImageContainer}>
              <LightBoxImage
                type={"masonry"}
                node={{
                  images: images,
                  className: masonryGrid,
                  columnClassName: masonryGridColumn,
                }}
              />
            </div>
          </section>
        </Layout>
      )}
    </FinalGalerieComponent>
  )
}

//-----------------------Component---------------------------//

//-----------------------Prop-Types---------------------------//

GalerieTemplate.propTypes = {
  data: PropTypes.object.isRequired,
}

//-----------------------Prop-Types---------------------------//

export default GalerieTemplate
